module.exports = __webpack_public_path__ + "img/GAME_LIGHTBUG1.54fe6505.jpg";